import { render } from "./Ayurvedam.vue?vue&type=template&id=22a1f9fc"
import script from "./Ayurvedam.vue?vue&type=script&lang=ts"
export * from "./Ayurvedam.vue?vue&type=script&lang=ts"
script.render = render

export default script